<script>
import {
  productCategoryItemLightProps,
  useProductCategoryItemLight
} from "./mixin";
import ListItem from "@/components/molecules/list/list-item";
import LazyImage from "@/components/atoms/lazy-image";
import ProductListItemAdvantage from "@/containers/avantages";
import List from "@/components/molecules/list";
import Alert from "@/components/molecules/alert";
import Icon from "@/components/atoms/icon";
import BadgeStatus from "@/components/molecules/badge-status";
import LinkTo from "@/components/atoms/link-to";
import PrixRemise from "@/containers/prix-remise";

export default {
  name: "ProductCategoryItemLight",
  components: {
    List,
    ListItem,
    LazyImage,
    ProductListItemAdvantage,
    Alert,
    Icon,
    BadgeStatus,
    LinkTo,
    PrixRemise
  },
  props: {
    ...productCategoryItemLightProps()
  },
  setup(props) {
    const { badgeColor, isLdd, prixTotalRemise } =
      useProductCategoryItemLight(props);

    return { badgeColor, isLdd, prixTotalRemise };
  }
};
</script>

<template>
  <ListItem
    :class="isLdd && 'c-product-category-item-light--ldd'"
    class="c-product-category-item-light"
  >
    <div class="c-product-category-item-light__line">
      <LazyImage
        :src="article.visuel"
        :dimension="64"
        class="c-product-category-item-light__image"
        height="48"
        width="48"
      />
      <div class="c-product-category-item-light_infos">
        <div class="c-product-category-item-light__description">
          <p class="c-product-category-item-light__title">
            {{ article.designation }}
          </p>
          <p
            v-if="article.prix_unite_reference"
            class="c-product-category-item-light__subtitle"
          >
            {{ formatPrix(article.prix_unite_reference) }} €
            {{ article.unite_reference }}
          </p>
          <p
            v-if="article.origine"
            class="c-product-category-item-light__subtitle"
          >
            {{ article.origine }}
          </p>
        </div>
        <div class="c-product-category-item-light_infos-wrap">
          <div class="c-product-category-item-light__commercial-infos">
            <ProductListItemAdvantage
              v-if="!avantagesCalcules && article.avantages"
              :advantages="article.avantages"
              :article="article"
              :show-actions="false"
              :cart-context="cartContext"
            />
            <List v-if="avantagesCalcules && article.avantages_animco">
              <ListItem
                v-if="article.avantages_animco.eurocora"
                class="c-product-category-item-light__advantages-order-item"
              >
                {{ euroCora(article.avantages_animco.eurocora) }} €
              </ListItem>
              <ListItem
                v-if="article.avantages_animco.points"
                class="c-product-category-item-light__advantages-order-item"
              >
                {{ pointFidelite(article.avantages_animco.points) }} points
              </ListItem>
              <ListItem
                v-if="article.avantages_animco.remise"
                class="c-product-category-item-light__advantages-order-item"
              >
                - {{ formatPrix(article.avantages_animco.remise) }}
              </ListItem>
            </List>
          </div>
          <p class="c-product-category-item-light__price">
            {{ formatPrix(article.prix) }} €
          </p>
          <p class="c-product-category-item-light__quantity">
            x {{ article.quantite }}
          </p>

          <p class="c-product-category-item-light__price-total">
            {{ formatPrix(article.prix_total_avec_remise) }} €
          </p>

          <div
            v-if="rating"
            class="c-product-category-item-light__rating"
          >
            <!-- <RateStarInteractive icon-size="xs">
          Noter ce produit
        </RateStarInteractive> -->
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="prixTotalRemise && prixTotalRemise !== article.prix_total_avec_remise"
      class="c-product-category-item-light__line"
    >
      <div class="c-product-category-item-light__remise">
        <PrixRemise
          :prix-remise="prixTotalRemise"
          price-size="sm"
        />
      </div>
    </div>
    <div
      v-if="isLdd"
      class="c-product-category-item-light__alert-wrapper"
    >
      <div v-if="isCommandeLdd && article.suivi">
        <BadgeStatus
          size="xs"
          :status="badgeColor(article.suivi.statut.code)"
          class="u-font-14"
        >
          {{ article.suivi.statut.libelle }}
        </BadgeStatus>
        <span
          v-if="article.suivi.url_tracking"
          class="u-ml-sm u-ml-md@sm"
        >
          <LinkTo
            :href="article.suivi.url_tracking"
            target="_blank"
            size="sm"
          >
            Voir le suivi
          </LinkTo>
        </span>
      </div>
      <Alert
        v-if="article.infos_vendeur || article.suivi"
        variant="grey-7"
        class="c-product-category-item-light__alert u-mt-sm"
      >
        <div class="u-flex u-flex-column">
          <div class="u-flex u-flex-align-center u-mb-xxs u-mr-md u-mr-none@sm">
            <Icon
              name="exclu-web"
              size="sm"
              class="u-flex-shrink-none u-flex-self-start"
            />

            <p class="u-font-700 u-font-13 u-ml-xs">
              Livraison sous
              {{
                (article.infos_vendeur &&
                  article.infos_vendeur.delai_livraison) ||
                  (article.suivi && article.suivi.delai_livraison_vendeur)
              }}
              jours ouvrés à compter de la validation de votre commande
            </p>
          </div>
          <div class="u-ml-lg u-mr-md u-mr-none@sm">
            <p class="u-font-700 u-font-13 u-mb-xxs">
              Conditions particulières de livraison
            </p>
            <p class="u-font-12">
              {{
                (article.infos_vendeur &&
                  article.infos_vendeur.conditions_livraison) ||
                  (article.suivi && article.suivi.conditions_livraison_vendeur)
              }}
            </p>
          </div>
        </div>
      </Alert>
    </div>
  </ListItem>
</template>

<style scoped lang="scss">
@import "@/assets/styles/components/product-category-item-light.scss";
</style>
